import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const SalesContactsLazy = lazy(() => import("./SalesContacts").then((m) => ({ default: m.SalesContacts })));

export const SalesContactsAsync = () => (
  <Suspense fallback={<LoadingIndicatorFullPage open />}>
    <SalesContactsLazy />
  </Suspense>
);
